import { Injectable } from '@angular/core'
import { Response } from '@angular/http'
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable'
import { AlertMessage } from '../model/alert-message'
import { HttpErrorResponse } from '@angular/common/http';


declare var $: any;

@Injectable()
export class ViewService {

    enableUI = false;
    isSelecting = false;

    private alert_message = new Subject<AlertMessage>()
    private resultInfo = new Subject<Object>()

    activateWebTab(delay = 0) {
        setTimeout(function() {
            $('#web>a').trigger('click');
        }, delay);
    }

    setHelp(str: string) {
        $('#help_article').html(str);
    }

    errorAlert(message: any | Response | HttpErrorResponse) {
        let alert: AlertMessage = new AlertMessage();
        if (message instanceof Response) {
            const body = message.json() || '';
            alert.header = message.statusText + ' ' + message.status;
            alert.text = body.error;
        } else if (message instanceof HttpErrorResponse) {
            alert.header = message.statusText;
            if (typeof message.error === 'string') {
                alert.text = message.error;
            }
        } else {
            alert.header = 'Error!';
            alert.text = message;
        }
        this.alert_message.next(alert);
        if (!this.enableUI) {
            this.enableUI = true;
        }
    }

    getMessage(): Observable<AlertMessage> {
        return this.alert_message.asObservable();
    }

    resultAlert(info: Object) {
        this.resultInfo.next(info);
    }

    getResult(): Observable<Object> {
        return this.resultInfo.asObservable();
    }
}
